'use client'

import { isObjectPage } from '@/services/pathname'
import { ReactNode, useId, useEffect, useRef, useState } from 'react'
import { object, z } from 'zod'
import { messages } from '@/services/validation'
import { status as s } from '@/services/status'
import { initRecaptcha } from '@/services/recaptcha/client'
import { checkRecaptcha } from '@/services/recaptcha/server'
import { postSharing } from '@/api/helper'
import Loading from '../../../app/loading'
import { getName } from '@/services/aroeven'

type TemporaryNoticeProps = {
    aroeven: Aroeven
}

export default function TemporaryNotice({
    aroeven
}: TemporaryNoticeProps) {

    const id = useId().replaceAll(':', '')
    const refModal = useRef(null)
    const [status, setStatus] = useState<string>(s.idle)
    const [errors, setErrors] = useState([])

    useEffect(() => {
        async function load() {
            const bootstrap = (await import('bootstrap/dist/js/bootstrap')).default;
            refModal.current = new bootstrap.Modal(document.getElementById(id + '-modal'))
            refModal.current.show()
        }
        load()
    }, [])

    return (
        <>
            <div className="modal fade" id={id + '-modal'} tabIndex={-1} role="dialog" aria-labelledby={id + '-button'} aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content border-0">
                        <div className="modal-header modal-colored-header bg-primary text-white">
                            <h4 className="modal-title text-white" id="primary-header-modalLabel">Information importante</h4>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="card-body p-3">
                                <h4 className="text-danger">Incident technique sur les inscriptions des 22/07 et 23/07</h4>
                                <p className='text-dark'>
                                    En raison d'un incident technique, les inscriptions effectuées sur notre site internet les 22/07 et 23/07 n'ont pas été enregistrées malgré l'affichage de l'écran de confirmation.<br /><br />
                                    Si vous avez tenté d'effectuer une inscription sur un séjour de vacances ou un stage BAFA/BAFD, que l'écran de confirmation indiquait "Montant à régler : 0 €" et que vous n'avez pas reçu d'email de confirmation, votre inscription est concernée et n'a pas été enregistrée. <br /><br />
                                    L'incident est désormais résolu, nous vous incitons à renouveler votre inscription.<br /><br />
                                    Si vous avez des questions à ce sujet, notre équipe se tient à votre entière disposition.<br /><br />
                                    Avec toutes nos excuses pour la gêne occasionnée,<br />
                                    {getName(aroeven)}
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer pt-0 pe-4">
                            <button className="button-outline" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

